import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollItemListSearchSchema } from '../-shared/payroll-item-list-search-schema';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/items/')({
  validateSearch: zodValidator(PayrollItemListSearchSchema)
});